import React, { useState} from 'react'
import bookshopImg from "../../../media/bookshop.svg";
import { Button, Modal, Result} from 'antd';


const Ebook = (props) => {
    const [modalVisible, setModalVisible] = useState(false); 
    const close = () =>{ setModalVisible(false)}
    const bookshop = props.bookshop;

    const displayBookshop = () => {
        return (
            <Result
            style={{"padding" : "20px"}}
            size="small"
            icon={<div aria-hidden><img alt="bookshop logo" height="48px" src={bookshopImg} /></div>}
            title={<><small>Before you go!</small><div className="shim" /></>}
            subTitle={<p style={{color: "rgba(0, 0, 0, 0.85)"}}>After selecting go, you will be taken to <strong>Bookshop.org</strong> for your ebook checkout and download. If you have any items in your cart here, remember to head back once you're done on Bookshop.org to checkout and complete your order.</p>}    
            extra={
                <><a target="_blank" aria-label="View on Libro.fm (opens in a new tab)"  rel="noopener noreferrer" href={bookshop}><Button type="primary">Go to Bookshop.org</Button></a></>
            }
        />)
    }

    return (<>
    <div aria-label="View ebook options" tabIndex={0} onClick={() => setModalVisible(true)} style={{"cursor" : "pointer"}}>  
        {props.children}
    </div>
    <Modal open={modalVisible} onCancel={close} destroyOnClose closable={true} footer={null}>
        {displayBookshop()}
    </Modal>
    </>

)
}

export default Ebook